/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface McpAuthorizationServerMetadataResponse
 */
export interface McpAuthorizationServerMetadataResponse {
    /**
     * 
     * @type {string}
     * @memberof McpAuthorizationServerMetadataResponse
     */
    issuer: string;
    /**
     * 
     * @type {string}
     * @memberof McpAuthorizationServerMetadataResponse
     */
    authorizationEndpoint: string;
    /**
     * 
     * @type {string}
     * @memberof McpAuthorizationServerMetadataResponse
     */
    tokenEndpoint: string;
    /**
     * 
     * @type {string}
     * @memberof McpAuthorizationServerMetadataResponse
     */
    revocationEndpoint: string;
    /**
     * 
     * @type {Array<McpAuthorizationServerMetadataResponseResponseTypesSupportedEnum>}
     * @memberof McpAuthorizationServerMetadataResponse
     */
    responseTypesSupported: Array<McpAuthorizationServerMetadataResponseResponseTypesSupportedEnum>;
    /**
     * 
     * @type {Array<McpAuthorizationServerMetadataResponseGrantTypesSupportedEnum>}
     * @memberof McpAuthorizationServerMetadataResponse
     */
    grantTypesSupported: Array<McpAuthorizationServerMetadataResponseGrantTypesSupportedEnum>;
    /**
     * 
     * @type {Array<McpAuthorizationServerMetadataResponseCodeChallengeMethodsSupportedEnum>}
     * @memberof McpAuthorizationServerMetadataResponse
     */
    codeChallengeMethodsSupported: Array<McpAuthorizationServerMetadataResponseCodeChallengeMethodsSupportedEnum>;
    /**
     * 
     * @type {Array<McpAuthorizationServerMetadataResponseTokenEndpointAuthMethodsSupportedEnum>}
     * @memberof McpAuthorizationServerMetadataResponse
     */
    tokenEndpointAuthMethodsSupported: Array<McpAuthorizationServerMetadataResponseTokenEndpointAuthMethodsSupportedEnum>;
    /**
     * 
     * @type {Array<McpAuthorizationServerMetadataResponseRevocationEndpointAuthMethodsSupportedEnum>}
     * @memberof McpAuthorizationServerMetadataResponse
     */
    revocationEndpointAuthMethodsSupported: Array<McpAuthorizationServerMetadataResponseRevocationEndpointAuthMethodsSupportedEnum>;
    /**
     * 
     * @type {Array<McpAuthorizationServerMetadataResponseScopesSupportedEnum>}
     * @memberof McpAuthorizationServerMetadataResponse
     */
    scopesSupported: Array<McpAuthorizationServerMetadataResponseScopesSupportedEnum>;
}


/**
 * @export
 */
export const McpAuthorizationServerMetadataResponseResponseTypesSupportedEnum = {
    Code: 'code'
} as const;
export type McpAuthorizationServerMetadataResponseResponseTypesSupportedEnum = typeof McpAuthorizationServerMetadataResponseResponseTypesSupportedEnum[keyof typeof McpAuthorizationServerMetadataResponseResponseTypesSupportedEnum];

/**
 * @export
 */
export const McpAuthorizationServerMetadataResponseGrantTypesSupportedEnum = {
    AuthorizationCode: 'authorization_code',
    RefreshToken: 'refresh_token'
} as const;
export type McpAuthorizationServerMetadataResponseGrantTypesSupportedEnum = typeof McpAuthorizationServerMetadataResponseGrantTypesSupportedEnum[keyof typeof McpAuthorizationServerMetadataResponseGrantTypesSupportedEnum];

/**
 * @export
 */
export const McpAuthorizationServerMetadataResponseCodeChallengeMethodsSupportedEnum = {
    S256: 'S256'
} as const;
export type McpAuthorizationServerMetadataResponseCodeChallengeMethodsSupportedEnum = typeof McpAuthorizationServerMetadataResponseCodeChallengeMethodsSupportedEnum[keyof typeof McpAuthorizationServerMetadataResponseCodeChallengeMethodsSupportedEnum];

/**
 * @export
 */
export const McpAuthorizationServerMetadataResponseTokenEndpointAuthMethodsSupportedEnum = {
    None: 'none'
} as const;
export type McpAuthorizationServerMetadataResponseTokenEndpointAuthMethodsSupportedEnum = typeof McpAuthorizationServerMetadataResponseTokenEndpointAuthMethodsSupportedEnum[keyof typeof McpAuthorizationServerMetadataResponseTokenEndpointAuthMethodsSupportedEnum];

/**
 * @export
 */
export const McpAuthorizationServerMetadataResponseRevocationEndpointAuthMethodsSupportedEnum = {
    None: 'none'
} as const;
export type McpAuthorizationServerMetadataResponseRevocationEndpointAuthMethodsSupportedEnum = typeof McpAuthorizationServerMetadataResponseRevocationEndpointAuthMethodsSupportedEnum[keyof typeof McpAuthorizationServerMetadataResponseRevocationEndpointAuthMethodsSupportedEnum];

/**
 * @export
 */
export const McpAuthorizationServerMetadataResponseScopesSupportedEnum = {
    McpRead: 'mcp:read'
} as const;
export type McpAuthorizationServerMetadataResponseScopesSupportedEnum = typeof McpAuthorizationServerMetadataResponseScopesSupportedEnum[keyof typeof McpAuthorizationServerMetadataResponseScopesSupportedEnum];


/**
 * Check if a given object implements the McpAuthorizationServerMetadataResponse interface.
 */
export function instanceOfMcpAuthorizationServerMetadataResponse(value: object): value is McpAuthorizationServerMetadataResponse {
    if (!('issuer' in value) || value['issuer'] === undefined) return false;
    if ((!('authorizationEndpoint' in (value as Record<string, any>)) && !('authorization_endpoint' in (value as Record<string, any>))) || ((value as Record<string, any>)['authorizationEndpoint'] === undefined && (value as Record<string, any>)['authorization_endpoint'] === undefined)) return false;
    if ((!('tokenEndpoint' in (value as Record<string, any>)) && !('token_endpoint' in (value as Record<string, any>))) || ((value as Record<string, any>)['tokenEndpoint'] === undefined && (value as Record<string, any>)['token_endpoint'] === undefined)) return false;
    if ((!('revocationEndpoint' in (value as Record<string, any>)) && !('revocation_endpoint' in (value as Record<string, any>))) || ((value as Record<string, any>)['revocationEndpoint'] === undefined && (value as Record<string, any>)['revocation_endpoint'] === undefined)) return false;
    if ((!('responseTypesSupported' in (value as Record<string, any>)) && !('response_types_supported' in (value as Record<string, any>))) || ((value as Record<string, any>)['responseTypesSupported'] === undefined && (value as Record<string, any>)['response_types_supported'] === undefined)) return false;
    if ((!('grantTypesSupported' in (value as Record<string, any>)) && !('grant_types_supported' in (value as Record<string, any>))) || ((value as Record<string, any>)['grantTypesSupported'] === undefined && (value as Record<string, any>)['grant_types_supported'] === undefined)) return false;
    if ((!('codeChallengeMethodsSupported' in (value as Record<string, any>)) && !('code_challenge_methods_supported' in (value as Record<string, any>))) || ((value as Record<string, any>)['codeChallengeMethodsSupported'] === undefined && (value as Record<string, any>)['code_challenge_methods_supported'] === undefined)) return false;
    if ((!('tokenEndpointAuthMethodsSupported' in (value as Record<string, any>)) && !('token_endpoint_auth_methods_supported' in (value as Record<string, any>))) || ((value as Record<string, any>)['tokenEndpointAuthMethodsSupported'] === undefined && (value as Record<string, any>)['token_endpoint_auth_methods_supported'] === undefined)) return false;
    if ((!('revocationEndpointAuthMethodsSupported' in (value as Record<string, any>)) && !('revocation_endpoint_auth_methods_supported' in (value as Record<string, any>))) || ((value as Record<string, any>)['revocationEndpointAuthMethodsSupported'] === undefined && (value as Record<string, any>)['revocation_endpoint_auth_methods_supported'] === undefined)) return false;
    if ((!('scopesSupported' in (value as Record<string, any>)) && !('scopes_supported' in (value as Record<string, any>))) || ((value as Record<string, any>)['scopesSupported'] === undefined && (value as Record<string, any>)['scopes_supported'] === undefined)) return false;
    return true;
}

export function McpAuthorizationServerMetadataResponseFromJSON(json: any): McpAuthorizationServerMetadataResponse {
    return McpAuthorizationServerMetadataResponseFromJSONTyped(json, false);
}

export function McpAuthorizationServerMetadataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): McpAuthorizationServerMetadataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'issuer': json['issuer'],
        'authorizationEndpoint': json['authorization_endpoint'],
        'tokenEndpoint': json['token_endpoint'],
        'revocationEndpoint': json['revocation_endpoint'],
        'responseTypesSupported': json['response_types_supported'],
        'grantTypesSupported': json['grant_types_supported'],
        'codeChallengeMethodsSupported': json['code_challenge_methods_supported'],
        'tokenEndpointAuthMethodsSupported': json['token_endpoint_auth_methods_supported'],
        'revocationEndpointAuthMethodsSupported': json['revocation_endpoint_auth_methods_supported'],
        'scopesSupported': json['scopes_supported'],
    };
}

export function McpAuthorizationServerMetadataResponseToJSON(json: any): McpAuthorizationServerMetadataResponse {
    return McpAuthorizationServerMetadataResponseToJSONTyped(json, false);
}

export function McpAuthorizationServerMetadataResponseToJSONTyped(value?: McpAuthorizationServerMetadataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'issuer': value['issuer'],
        'authorization_endpoint': value['authorizationEndpoint'],
        'token_endpoint': value['tokenEndpoint'],
        'revocation_endpoint': value['revocationEndpoint'],
        'response_types_supported': value['responseTypesSupported'],
        'grant_types_supported': value['grantTypesSupported'],
        'code_challenge_methods_supported': value['codeChallengeMethodsSupported'],
        'token_endpoint_auth_methods_supported': value['tokenEndpointAuthMethodsSupported'],
        'revocation_endpoint_auth_methods_supported': value['revocationEndpointAuthMethodsSupported'],
        'scopes_supported': value['scopesSupported'],
    };
}

